module.exports = __webpack_public_path__ + "img/free-standing-wall-3.e85207d9.jpeg";